<template>
  <div class="sp-page" :class="{ 'has-footer': hasFooter }">
    <Header :title="title" :showBack="showBack" @back="onBack" :storeSelectable="storeSelectable">
      <slot name="header" />
    </Header>
    <main>
      <slot />
      <LoadingIndicator v-if="loading" />
    </main>
    <PageFooter v-if="hasFooter">
      <slot name="footer"></slot>
    </PageFooter>
  </div>
</template>

<script>
import Header from '@/components/organisms/Header'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import PageFooter from '@/components/molecules/PageFooter'

/**
 * SP版ページ
 */
export default {
  name: 'SpPage',
  components: {
    Header,
    LoadingIndicator,
    PageFooter,
  },
  props: {
    /** タイトル */
    title: String,
    /** 戻るボタン */
    showBack: { type: Boolean, default: false },
    /** ロード中 */
    loading: { type: Boolean, default: false },
    /** 店舗選択可能かどうか */
    storeSelectable: { type: Boolean, default: false },
  },
  computed: {
    hasFooter() {
      return !!this.$slots.footer
    },
  },
  methods: {
    onBack() {
      /**
       * 戻るボタンのクリック
       * @event
       */
      this.$emit('back')
    },
  },
}
</script>

<style lang="postcss" scoped>
.sp-page {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hiddon;
  -webkit-overflow-scrolling: touch;
  position: relative;

  main {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
  }

  &.has-footer {
    padding-bottom: 72px;
  }
}
</style>
